// extracted by mini-css-extract-plugin
module.exports = {"image":"section-nouille-module--image--3P7_Z"};